module.exports = __webpack_public_path__ + "static/media/StarRight.9e2fdfef.svg";